import {
  addCalendarDays,
  getLabTodayDateOnly,
  requireDateOnlyString,
  type DateOnlyString,
} from "../../utils/dateOnly";

export interface WorkloadPickerDateRange {
  readonly startDate: Date;
  readonly endDate: Date;
}

export interface WorkloadRequestDateRange {
  readonly startDate: DateOnlyString;
  readonly endDate: DateOnlyString;
}

export function workloadRequestDateRange(
  range: WorkloadPickerDateRange
): WorkloadRequestDateRange {
  return {
    startDate: pickerDateToDateOnly(range.startDate),
    endDate: pickerDateToDateOnly(range.endDate),
  };
}

export function getDefaultWorkloadDateRange(
  now: Date = new Date()
): WorkloadPickerDateRange {
  const labToday = getLabTodayDateOnly(now);
  const currentMonthStart = requireDateOnlyString(
    `${labToday.slice(0, 7)}-01`,
    "Current laboratory month"
  );
  const previousMonthEnd = requirePreviousCalendarDay(currentMonthStart);
  const previousMonthStart = requireDateOnlyString(
    `${previousMonthEnd.slice(0, 7)}-01`,
    "Previous laboratory month"
  );
  return {
    startDate: dateOnlyToPickerDate(previousMonthStart),
    endDate: dateOnlyToPickerDate(previousMonthEnd),
  };
}

function pickerDateToDateOnly(value: Date): DateOnlyString {
  return requireDateOnlyString(
    `${value.getFullYear()}-${padTwoDigits(
      value.getMonth() + 1
    )}-${padTwoDigits(value.getDate())}`,
    "Workload report date"
  );
}

function dateOnlyToPickerDate(value: DateOnlyString): Date {
  const [year, month, day] = value.split("-").map(Number);
  return new Date(year, month - 1, day);
}

function requirePreviousCalendarDay(value: DateOnlyString): DateOnlyString {
  const previous = addCalendarDays(value, -1);
  if (!previous) throw new Error("Unable to derive previous laboratory month");
  return previous;
}

function padTwoDigits(value: number): string {
  return String(value).padStart(2, "0");
}
